import type { SchemaCorporationResolver_GetOwnCorporation } from 'cpool-tables/backend-resolvers';

// chat gating and starting must share this lookup
export const findOwnDivisionPhoneNumberId = (
    corporation: Pick<SchemaCorporationResolver_GetOwnCorporation, 'divisions'> | undefined,
    divisionId: string | null | undefined,
) => corporation?.divisions.find((division) => division.id === divisionId)?.phoneNumberId;
